import Vue3TouchEvents from "vue3-touch-events";

export default defineNuxtPlugin((app) => {
	app.vueApp.use(Vue3TouchEvents);
});
